<template>
  <b-form-invalid-feedback :state="state">
    {{ errorMsg }}
  </b-form-invalid-feedback>
</template>

<script>
import { BFormInvalidFeedback } from 'bootstrap-vue'

const messages = {
  es: {
    'vuelidate': {
      'errors': {
        'required': 'Este campo es obligatorio',
        'minLength': 'Este campo debe tener al menos {value} caracteres',
        'maxLength': 'Este campo no debe tener más de {value} caracteres',
        'minValue': 'Este campo debe tener un valor mayor o igual a {value}',
        'email': 'Este campo debe ser un email válido',
        'numeric': 'Este campo debe ser numérico',
        'afterToday': 'La fecha debe ser posterior a hoy',
        'afterDate': 'La fecha debe ser posterior a {value}',
        'beforeDate': 'La fecha debe ser anterior a {value}',
        'beforeToday': 'La fecha debe ser anterior a hoy',
        'sameAsPassword': 'Las contraseñas no coinciden',
        'hasNumber': 'Debe contener al menos un número',
        'hasSpecialChar': 'Debe contener al menos un caracter especial',
        'hasUpperCase': 'Debe contener al menos una letra mayúscula',
        'hasLowerCase': 'Debe contener al menos una letra minúscula'
      }
    }
  },
  en: {
    'vuelidate': {
      'errors': {
        'required': 'This field is required',
        'minLength': 'This field must have at least {value} characters',
        'maxLength': 'This field must have less than {value} characters',
        'minValue': 'This field must have a value greater or equal to {value}',
        'email': 'This field must be a valid email',
        'numeric': 'This field must be numeric',
        'afterToday': 'The date must be after today',
        'afterDate': 'The date must be after {value}',
        'beforeDate': 'The date must be before {value}',
        'beforeToday': 'The date must be before today',
        'sameAsPassword': 'Passwords do not match',
        'hasNumber': 'Must contain at least one number',
        'hasSpecialChar': 'Must contain at least one special character',
        'hasUpperCase': 'Must contain at least one uppercase letter',
        'hasLowerCase': 'Must contain at least one lowercase letter'
      }
    }
  },
  pt: {
    'vuelidate': {
      'errors': {
        'required': 'Este campo é obrigatório',
        'minLength': 'Este campo deve ter pelo menos {value} caracteres',
        'maxLength': 'Este campo não deve ter mais de {value} caracteres',
        'minValue': 'Este campo deve ter um valor maior ou igual a {value}',
        'email': 'Este campo deve ser um email válido',
        'numeric': 'Este campo deve ser numérico',
        'afterToday': 'A data deve ser posterior a hoje',
        'afterDate': 'A data deve ser posterior a {value}',
        'beforeDate': 'A data deve ser anterior a {value}',
        'beforeToday': 'A data deve ser anterior a hoje',
        'sameAsPassword': 'As senhas não coincidem',
        'hasNumber': 'Deve conter pelo menos um número',
        'hasSpecialChar': 'Deve conter pelo menos um caracter especial',
        'hasUpperCase': 'Deve conter pelo menos uma letra maiúscula',
        'hasLowerCase': 'Deve conter pelo menos uma letra minúscula'
      }
    }
  }
}

export default {
  name: 'vuelidate-error',
  components: {
    BFormInvalidFeedback
  },
  i18n: {
    messages
  },
  props: {
    state: {
      type: Boolean,
      required: false,
      default: null
    },
    validator: {
      type: Object,
      required: false,
      default: null
    },
    requiredErrorMsg: {
      type: String,
      required: false,
      default () {
        return this.$t('vuelidate.errors.required')
      }
    },
    parentValidators: {
      type: Object,
      required: false,
      default: null
    }
  },
  computed: {
    errorMsg () {
      if (!this.validator || this.validator['required'] === false) {
        return this.requiredErrorMsg
      }
      for (var prop in this.validator) {
        if (this.validator[prop] === false) {
          const msgKey = `vuelidate.errors.${prop}`
          const params = this.validator.$params[prop]
          const value = params ? (params.value || params.min || params.max || params.minDate || params.maxDate || params.minValue || params.maxValue) : null
          return value ? this.$t(msgKey, { value: value }) : this.$t(msgKey)
        }
      }
    }
  }

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/base/forms/VuelidateError.vue